/* My Logs view: the caller's own audit-log entries. */
import React from 'react';
import { myActivity } from '../api.js';

export const LogsView = () => {
  const [entries, setEntries] = React.useState(null);
  const [error, setError] = React.useState(null);

  const reload = React.useCallback(() => {
    setError(null);
    myActivity(300)
      .then(setEntries)
      .catch(err => setError(err.message));
  }, []);

  React.useEffect(() => { reload(); }, [reload]);

  return (
    <div className="page">
      <div className="page__head">
        <h1>My Logs</h1>
        <div className="lede">Every action you've taken in eOS — intents, workers, OrgRepo edits, agent runs, profile updates. The activity here also feeds your personal reflection agent.</div>
      </div>

      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14}}>
        {entries && <span style={{fontSize:12,color:'var(--fg-muted)'}}>{entries.length} entries</span>}
        <div style={{flex:1}}/>
        <button className="btn-ghost" onClick={reload} style={{fontSize:12,padding:'4px 10px'}}>Refresh</button>
      </div>

      {error && <div style={{padding:12,background:'#FCE6E0',color:'#A20235',borderRadius:8,fontSize:13,marginBottom:14}}>{error}</div>}

      {entries === null && !error && (
        <div style={{padding:24,color:'var(--fg-muted)',fontSize:13}}>Loading…</div>
      )}

      {entries && entries.length === 0 && (
        <div style={{padding:14,background:'var(--bg-alt)',borderRadius:8,fontSize:13,color:'var(--fg-muted)'}}>
          No activity yet. Spawn a worker, open an intent, or edit OrgRepo and it'll show up here.
        </div>
      )}

      {entries && entries.length > 0 && (
        <table className="tbl">
          <thead><tr>
            <th style={{width:140}}>When</th>
            <th style={{width:220}}>Action</th>
            <th>Target</th>
            <th style={{width:90}}>Severity</th>
          </tr></thead>
          <tbody>
            {entries.map(e => (
              <tr key={e.id}>
                <td style={{color:'var(--fg-muted)',fontSize:12}}>{relTime(e.createdAt)}</td>
                <td style={{fontFamily:'JetBrains Mono',fontSize:12}}>{e.action}</td>
                <td>{e.target
                  ? <span><span style={{color:'var(--fg-muted)',fontSize:11}}>{e.target.type}: </span>{e.target.label || e.target.id || '—'}</span>
                  : '—'}</td>
                <td>
                  <span style={{
                    fontSize:11,padding:'2px 8px',borderRadius:4,
                    background: e.severity === 'high' ? '#FCE6E0' : e.severity === 'medium' ? '#FFE7DC' : 'var(--bg-card)',
                    color:      e.severity === 'high' ? '#A20235' : e.severity === 'medium' ? '#B83C0F' : 'var(--fg-muted)',
                    textTransform:'uppercase',letterSpacing:'0.04em',
                  }}>{e.severity}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

function relTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  const abs = Math.abs(Date.now() - d.getTime());
  const min = 60_000, hr = 60 * min, day = 24 * hr;
  if (abs < min)     return 'just now';
  if (abs < hr)      return `${Math.round(abs / min)}m ago`;
  if (abs < day)     return `${Math.round(abs / hr)}h ago`;
  if (abs < 7 * day) return `${Math.round(abs / day)}d ago`;
  return d.toLocaleDateString();
}
